import React from "react";

/**
 * YOUR CUT Logo
 * Verwendet die echte Logo-Grafik (transparent zugeschnitten, Aspect-Ratio ≈ 3.6:1).
 * Höhen-basierte Skalierung damit nichts verzerrt – Breite ergibt sich automatisch.
 */
export const Logo = ({ size = "md", showSubtitle = false, className = "" }) => {
  const heights = {
    sm: "h-7",
    md: "h-8 md:h-9",
    lg: "h-10 md:h-12",
    xl: "h-16 sm:h-20 md:h-24 lg:h-28",
  };
  const subSizes = {
    sm: "text-[10px]",
    md: "text-xs",
    lg: "text-sm",
    xl: "text-lg sm:text-xl md:text-2xl",
  };
  const h = heights[size] || heights.md;
  const sub = subSizes[size] || subSizes.md;

  return (
    <div className={`flex flex-col ${className}`} data-testid="brand-logo">
      <img
        src="/logo-yourcut.png"
        alt="YOUR CUT Herren Friseur Salon Hamburg"
        className={`${h} w-auto select-none object-contain`}
        draggable="false"
      />
      {showSubtitle && (
        <div
          className={`font-script text-white/75 mt-2 ${sub} tracking-wide`}
        >
          Herren Friseur Salon
        </div>
      )}
    </div>
  );
};
